<div class="page-shell">
<mat-toolbar class="header">
  <span>{{ "auditLog.events" | translate }}: {{ total }}</span>
  <div class="actions">
    <button mat-stroked-button type="button" (click)="export('csv')">
      <mat-icon>download</mat-icon>
      {{ "auditLog.exportCsv" | translate }}
    </button>
    <button mat-stroked-button type="button" (click)="export('json')">
      <mat-icon>download</mat-icon>
      {{ "auditLog.exportJson" | translate }}
    </button>
  </div>
</mat-toolbar>

<div class="audit-log-wrapper">
  <form [formGroup]="filters" class="filters-row">
    <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
      <input
        matInput
        formControlName="search"
        [placeholder]="'auditLog.searchPlaceholder' | translate"
        [attr.aria-label]="'auditLog.search' | translate"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <app-searchable-select
      class="domain-select"
      [label]="'domain' | translate"
      [value]="selectedDomain"
      (valueChange)="onDomainChange($event)"
      [options]="availableDomains"
      [displayWith]="domainLabel"
      [valueWith]="domainValue"
      subscriptSizing="dynamic"
    ></app-searchable-select>

    <app-searchable-select
      formControlName="actionType"
      [label]="'auditLog.actionType' | translate"
      [options]="actionTypes"
      [displayWith]="identityLabel"
      [valueWith]="identityLabel"
      [emptyLabel]="'auditLog.all' | translate"
      [emptyValue]="null"
      subscriptSizing="dynamic"
    ></app-searchable-select>

    <app-searchable-select
      formControlName="entityType"
      [label]="'auditLog.entityType' | translate"
      [options]="entityTypes"
      [displayWith]="identityLabel"
      [valueWith]="identityLabel"
      [emptyLabel]="'auditLog.all' | translate"
      [emptyValue]="null"
      subscriptSizing="dynamic"
    ></app-searchable-select>
    <app-range-calendar
      [label]="'auditLog.dateRange' | translate"
      [dateRangeForm]="dateRangeForm"
    ></app-range-calendar>
  </form>

  <div
    class="table-container"
    [class.table-container--empty]="isEmpty || showNoSearchResults"
    [class.table-container--loading]="loading"
  >
    <mat-table
      [dataSource]="dataSource"
      matSort
      matSortDisableClear
      [matSortActive]="sortBy"
      [matSortDirection]="sortDirection"
      (matSortChange)="onSortChange($event)"
      class="audit-table mat-elevation-z0"
    >
      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          "auditLog.timestamp" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{
          element.createdAt | localizedDate : "short"
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          "auditLog.userEmail" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.email }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actionType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          "auditLog.actionType" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.actionType }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="entityType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          "auditLog.entityType" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.entityType }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="entityName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          "auditLog.affectedEntity" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{
          element.entityName || element.entityId || "-"
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="summary">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          "auditLog.summary" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.summary }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="details">
        <mat-header-cell *matHeaderCellDef>{{
          "details" | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="table-actions">
            <button type="button" class="action-btn" (click)="openDetails(element); $event.stopPropagation()">
              <mat-icon>description</mat-icon>
              {{ "details" | translate }}
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="table-row--clickable"
        (click)="openDetails(row)"
      ></mat-row>
    </mat-table>

    <div class="loading-wrapper" *ngIf="loading">
      <app-loading></app-loading>
    </div>

    <div class="empty-state" *ngIf="!loading && isEmpty">
      <mat-icon class="empty-state__icon">history</mat-icon>
      <p>{{ "auditLog.noData" | translate }}</p>
    </div>

    <div class="empty-state" *ngIf="showNoSearchResults">
      <mat-icon class="empty-state__icon">search_off</mat-icon>
      <p>{{ "auditLog.noData" | translate }}</p>
    </div>
  </div>

  <mat-paginator
    *ngIf="total > 0"
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPage($event)"
    showFirstLastButtons
  ></mat-paginator>
</div>
</div>
